<div class="node-toolbar" 
    [style.top.px]="navPanelData.top" 
    [style.left.px]="navPanelData.left" 
    [style.visibility]="navPanelData.visibility" 
    [style.width]="navPanelData.width + 'px'"  >
    <app-node-toolbar></app-node-toolbar>
</div>
<div class="user-list"   
    [style.top.px]="userListData.top" 
    [style.left.px]="userListData.left" 
    [style.visibility]="userListData.visibility" >
    <app-users-list [users]="userListData.data"></app-users-list>
</div>
<div class="attachments-list"   
    [style.top.px]="attachmentsData.top" 
    [style.left.px]="attachmentsData.left" 
    [style.visibility]="attachmentsData.visibility" >
    <app-attachments-list 
        [attachments]="attachmentsData.data" 
        [attachType]="attachmentsData.attachType"
        [task_alias]="attachmentsData.task_alias">
    </app-attachments-list>
</div>
<button *ngIf="stageSettings?.showSettingsButton"
    (click)="openGraphSettings()" data-action="graphSettings" class="button-icon size-l icononly secondary-button"
    style="position: fixed; top:180px; left:65px;z-index: 100; "
    matTooltip="{{ 'GRAPH.BUTTONS.SETTINGS'  | translate }}" >
    <mat-icon svgIcon="settings-3-fill"> </mat-icon>
</button>
<div

    class="konva"
    id="graph-container"
    style="margin-left: -3vw; width: 99vw;"
    >
</div>
<div class="loading" *ngIf="graphIsLoading" >
    <div>Построение графа....</div>
</div>
<div id="graph-context-menu">
    <div>
        <button id="more">...</button>
    </div>
</div>